import api from '@/services/api';

/**
 * Board #251 — changing or detaching the agent (POSP) on an existing policy.
 *
 * Posted to `POST /api/v1/policies/:id/update-posp/` (PolicyViewSet.update_posp).
 * `posp: null` is the DETACH instruction and is deliberately sent as an explicit
 * null rather than omitted — the server refuses a body with no `posp` key at all,
 * so a request that merely forgot the field can never be read as "detach".
 *
 * The server is the guard, not this file. Detaching an agent who has already
 * been paid is refused with an exact sentence the caller must surface verbatim,
 * and the same refusal is enforced on the plain PATCH edit-form path — hiding
 * the button is not a guard, and hidden-only guards have been bypassed here.
 */
export interface UpdatePOSPResponse {
  message: string;
  policy_id: string;
  /** The STORED value, re-read after the write — not what the client asked for. */
  posp: string | null;
  posp_name: string | null;
  /** Commission rows the detach had to supersede itself; 0 on the normal path. */
  commission_rows_superseded: number;
}

export async function updatePolicyPOSP(
  policyId: string,
  posp: string | null,
  remark?: string,
): Promise<UpdatePOSPResponse> {
  const body: { posp: string | null; remark?: string } = { posp };
  const trimmed = (remark || '').trim();
  if (trimmed) body.remark = trimmed;
  const response = await api.post<UpdatePOSPResponse>(`/policies/${policyId}/update-posp/`, body);
  return response.data;
}
